import dayjs from "dayjs";
import Portfolio from "@/lib/models/Portfolio";


export default {
    methods:{
        generateInvestments(portfolio: Portfolio, dates: Array<{text: string, dateFrom: dayjs.Dayjs, dateTo: dayjs.Dayjs}>) {
            let previousValue = 0;
            const values: number[] = [];
            const investments = portfolio.moves.sort((a, b) => a.date > b.date ? 1 : -1);

            dates.forEach(date => {
                const dateValidInvestments = investments.filter(investment => dayjs(investment.date).isAfter(date.dateFrom) && dayjs(investment.date).isBefore(date.dateTo));
                const value = dateValidInvestments.length > 0 ? (previousValue + dateValidInvestments.reduce((p, c) => {
                    return p + Number(c.price);
                }, 0)) : previousValue;
                values.push(value);
                previousValue = value;
            });
            return values;
        },
        generatePriceInTimes(portfolio: Portfolio, dates: Array<{text: string, dateFrom: dayjs.Dayjs, dateTo: dayjs.Dayjs}>) {
            let previousValue = 0;
            const values: number[] = [];
            const investments = portfolio.priceUpdates.sort((a, b) => a.date > b.date ? 1 : -1);

            dates.forEach(date => {
                const dateValidInvestments = investments.filter(investment => dayjs(investment.date).isAfter(date.dateFrom) && dayjs(investment.date).isBefore(date.dateTo));
                // @ts-ignore
                const value = dateValidInvestments.length > 0 ? Number(dateValidInvestments.slice(-1).pop().price) : previousValue;
                values.push(value);
                previousValue = value;
            });

            return values;
        },
        generateProfits(investments: number[], totalPrices: number[]) {
            let previousValue = 0;
            const values: number[] = [];

            investments.forEach((investment, index) => {
                const currentValue = totalPrices[index] - investment;
                previousValue = Math.round(currentValue * 100) / 100;
                values.push(currentValue)
            });

            return values;
        }
    }
}
